import PropTypes from 'prop-types';
import { ALIGNMENT_OPTIONS } from './alignment';
import { Link } from 'react-router-dom';

export const ALIGNMENT_PROPTYPES = PropTypes.oneOf(ALIGNMENT_OPTIONS);

export const BUTTON_COMPONENT_PROPTYPES = PropTypes.oneOf([Link, 'a']);

export const MENU_ITEM_PROPTYPES = {
  name: PropTypes.string,
  description: PropTypes.string,
  calories: PropTypes.number,
  // DIETY + ALLERGEN PROPS
  contains_sugar: PropTypes.bool,
  cooked_to_order: PropTypes.bool,
  corn: PropTypes.bool,
  corn_free: PropTypes.bool,
  dairy: PropTypes.bool,
  dairy_free: PropTypes.bool,
  dairy_free_option: PropTypes.bool,
  egg: PropTypes.bool,
  egg_free: PropTypes.bool,
  fish: PropTypes.bool,
  fish_free: PropTypes.bool,
  gluten: PropTypes.bool,
  gluten_free: PropTypes.bool,
  gluten_free_option: PropTypes.bool,
  halal: PropTypes.bool,
  keto: PropTypes.bool,
  keto_option: PropTypes.bool,
  kosher: PropTypes.bool,
  kosher_option: PropTypes.bool,
  low_fodmap: PropTypes.bool,
  low_sodium: PropTypes.bool,
  non_alcoholic: PropTypes.bool,
  nuts: PropTypes.bool,
  nuts_free: PropTypes.bool,
  organic: PropTypes.bool,
  organic_option: PropTypes.bool,
  paleo: PropTypes.bool,
  paleo_option: PropTypes.bool,
  peanut: PropTypes.bool,
  peanut_free: PropTypes.bool,
  plant_based: PropTypes.bool,
  plant_based_option: PropTypes.bool,
  raw: PropTypes.bool,
  raw_egg: PropTypes.bool,
  sesame: PropTypes.bool,
  sesame_free: PropTypes.bool,
  shellfish: PropTypes.bool,
  shellfish_free: PropTypes.bool,
  soy: PropTypes.bool,
  soy_free: PropTypes.bool,
  spicy: PropTypes.bool,
  spicy_hot: PropTypes.bool,
  spicy_medium: PropTypes.bool,
  spicy_mild: PropTypes.bool,
  sugar_free: PropTypes.bool,
  tree_nut: PropTypes.bool,
  tree_nut_free: PropTypes.bool,
  uncooked: PropTypes.bool,
  undercooked: PropTypes.bool,
  vegan: PropTypes.bool,
  vegan_option: PropTypes.bool,
  vegetarian: PropTypes.bool,
  vegetarian_option: PropTypes.bool,
  wheat: PropTypes.bool,
  wheat_free: PropTypes.bool
};

/* all online ordering locations are associated with an online ordering location */
const BOX_LOCATION_PROPTYPES = PropTypes.shape({
  lat: PropTypes.string,
  lng: PropTypes.string,
  street: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  postal_code: PropTypes.string,
  phone_number: PropTypes.string
});

export const ONLINE_ORDERING_LOCATION_PROPTYPES = PropTypes.shape({
  title: PropTypes.string,
  location: BOX_LOCATION_PROPTYPES.isRequired,
  description: PropTypes.string,
  is_closed: PropTypes.bool,
  distance_to_address: PropTypes.string
});

export const LOCATION_LIST_PROPTYPES = PropTypes.arrayOf(
  ONLINE_ORDERING_LOCATION_PROPTYPES
);
